import React, {useEffect, useState} from 'react';

import './Patients.patient.scss';
import moment from 'moment';
import { PatientAvatar } from '../visuals/Patient.avatar';
import ModalPatientExtent from '../visuals/ModalPatientExtent'
import ItemMenu from '../forms/menu/MenuComponent';
import {useNavigate} from 'react-router-dom';
import { useMutation } from '@apollo/client';
import gqlSchemaLibrary from '../services/graphql.schemas';
import EnrollPatientDialog from "./Patient.enroll";
import {getDateFormat} from "../utils/date";
import {useTranslation} from "react-i18next";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";

function PatientBasePatient({ currentOrg, currentUser, patient, selected, onSelected, programOptions, onUpdatePatient }) {
    const {t} = useTranslation(['participants','users','common']);
    const [extendEnrollmentModal, setExtendEnrollmentModal] = useState(false);
    const [openEnrollPatient, setOpenEnrollPatient] = useState(false);
    const [state, setState] = useState(1);
    const [_patient, setPatient] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!!patient) {
            setPatient(patient);
        }
    }, [patient]);

    const [unPauseEnrollment] = useMutation(gqlSchemaLibrary.patients.mutations.unPauseEnrollment, {
        onCompleted: ({ unPauseEnrollment }) => {
            console.log('unPauseEnrollment: ', unPauseEnrollment);
            onUpdatePatient(unPauseEnrollment)
        }
    });

    const handleClick = () => {
        AuditTrail.sendLog(PAGES.PARTICIPANTS_LIST, {tag: 'row', event: 'onClick', action: 'click row patient', patient_id: patient._id});
        onSelected(_patient)
    }
    const programName = () => {
        const program = programOptions.find(po => po._id === _patient.programId);
        return !!program && program.name ? program.name : t('no-program');
    }
    const goToEditPatient = () => {
        AuditTrail.sendLog(PAGES.PARTICIPANTS_LIST, {tag: 'button', event: 'onClick', action: 'click option edit patient', patient_id: patient._id});
        navigate(`/participants/edit/${_patient._id}`);
    }
    const goToViewPatient = () => {
        AuditTrail.sendLog(PAGES.PARTICIPANTS_LIST, {tag: 'button', event: 'onClick', action: 'click option detail patient', patient_id: patient._id});
        navigate(`/participants/view/${_patient._id}`);
    }
    const openModalExtendEnrollment = (state) => {
        return () => {
            setState(state);
            if (state === 2 && _patient.isPaused) {
                // This is an unpause event
                AuditTrail.sendLog(PAGES.PARTICIPANTS_LIST, {tab: 'button', event: 'onClick', action: 'button unpause enrollment', patientId: patient._id});
                unPauseEnrollment({
                    variables: {
                        personId: _patient._id
                    }
                })
            } else {
                setExtendEnrollmentModal(true);
            }
        }
    }
    const openModalEnroll = () => {
        setOpenEnrollPatient(true);
    }
    const onCloseModalEnroll = (patientId, programId) => {
        setOpenEnrollPatient(false);
        if (patientId) {
            let p = Object.assign({}, _patient);
            p.programId = programId;
            p.isDisenrolled = false;
            onUpdatePatient(p);
        }
    }
    const onStatusChange = (updatedPatient) => {
        console.log('updatedPatient: ', updatedPatient);
        setExtendEnrollmentModal(false);
        onUpdatePatient(updatedPatient);
    }
    const getPatientStatus = () => {
        if (_patient.isPaused && !_patient.isDisenrolled) { return 'paused' }
        else if (_patient.isDisenrolled) { return 'disenrolled' }
        else if (!_patient.programId) { return 'registered' }
        else if (_patient.programId) { return 'enrolled' }
    }

    if (!_patient) {
        return '';
    }

    const getPhone = (phone) => {
        if (!phone || !phone.number) {
            return '--';
        }
        if (phone.number.search(/\+/) !== -1) {
                return phone.number;
            }
        return '+' + phone.code + ' ' + phone.number;
    }

    const phone = _patient.phones.find(ph => ph.label === t('users:mobile')) || _patient.phones[0];
    const dobMoment = _patient.dateOfBirth? moment(_patient.dateOfBirth) : 0;
    return (
        <div className={`__PatientBasePatient ${selected ? 'selected' : ''}`} onClick={handleClick}>
            <PatientAvatar bio={_patient.user.bio} small={true} status={getPatientStatus()} />
            <div className="name">
                <h3 onClick={goToViewPatient}>
                    {_patient.user.bio.lastname}, {_patient.user.bio.firstname}
                </h3>
                {
                    _patient.isNew ?
                        <div className="_isNew">
                            {t('common:new').toUpperCase()}
                    </div>
                        : ''
                }
            </div>
            <p className="centered">
                { dobMoment? moment().diff(dobMoment, 'years') : '--'}
            </p>
            <p>
                {_patient.user.bio.gender}
            </p>
            <p>
                {getDateFormat(currentOrg, _patient.dateOfBirth, 'short')}
            </p>
            <p>
                {
                    getPhone(phone)
                }
            </p>
            <p>
                {programName()}
            </p>
            {
                _patient.isDisenrolled ?
                    <div className="noData disenrolled">
                        <p>
                            {
                                _patient.timeline.length <= 1? t('not-enrolled') : t('disenrolled')
                            }
                        </p>
                    </div>
                    : (
                        _patient.isPaused ?
                            <div className="noData paused">
                                <p>
                                    {t('paused')}
                                </p>
                            </div>
                            :
                            (
                                _patient.programId?
                                    (
                                      !_patient.lastDataSeen?
                                           <div className="noData data">
                                                <p>
                                                    {t('common:no-data')}
                                                </p>
                                           </div> :
                                          <div className="noData enrolled">
                                            <p>{t('enrolled')}</p>
                                        </div>
                                    ) : <div></div>
                            )
                    )
            }
            <div>
                {
                    !currentUser.userRoles.userPatients.edit &&
                        !currentUser.userRoles.programsEnroll.edit &&
                        !currentUser.userRoles.programsEnroll.create ?
                        <div /> :
                        <ItemMenu actionWillRedirect={false} fixed={true} label={'Participant Options'}
                                  event={PAGES.PARTICIPANTS_LIST} eventParams={{patient_id: patient._id}}>
                            <>
                                {
                                    currentUser.userRoles.userPatients.edit ?
                                        <div className="_option" onClick={goToEditPatient}>
                                            <p>{t('edit-participant')}</p>
                                        </div>
                                        : ''
                                }
                                <div className="_option" onClick={goToViewPatient}>
                                    <p>{t('participant-details')}</p>
                                </div>
                                {
                                    !_patient.programId?
                                        <div className="_option" onClick={openModalEnroll}>
                                            <p>{t('enroll')}</p>
                                        </div> : ''
                                }
                                {
                                    currentUser.userRoles.programsEnroll.edit && !!_patient.programId?
                                        <div className="_option" onClick={openModalExtendEnrollment(1)}>
                                            <p>{t('extend-enrollment')}</p>
                                        </div>
                                        : ''
                                }
                                {
                                    !_patient.programId || !!_patient && _patient.isDisenrolled ?
                                        '' :
                                        (
                                            currentUser.userRoles.programsEnroll.edit ?
                                                <div className="_option" onClick={openModalExtendEnrollment(2)}>
                                                    <p>{!!_patient && _patient.isPaused ? t('unpause') : t('pause')} {t('enrollment')}</p>
                                                </div>
                                                : '')
                                }
                                {
                                    !_patient.programId || !!_patient && _patient.isDisenrolled ?
                                        '' :
                                        (
                                            currentUser.userRoles.programsEnroll.edit ?
                                                <div className="_option" onClick={openModalExtendEnrollment(3)}>
                                                    <p>{t('disenroll')}</p>
                                                </div>
                                                : '')
                                }
                            </>
                        </ItemMenu>

                }
            </div>
            {
                <ModalPatientExtent currentOrg={currentOrg} state={state} patient={_patient} isOpen={extendEnrollmentModal} onStatusChange={onStatusChange} />
            }
            {
                <EnrollPatientDialog patient={_patient} isOpen={openEnrollPatient} closeModal={onCloseModalEnroll} />
            }
        </div>
    )
}

export default PatientBasePatient;
